module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hidden && !_vm.disabled),
      expression: "!hidden && !disabled"
    }],
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "graph-container"
  }, [_c('div', {
    staticClass: "graph-title"
  }, [_vm._v("\n                " + _vm._s(_vm.title) + "\n                "), _c('div', {
    staticClass: "graph-title-buttons"
  }, [_c('div', {
    staticClass: "graph-title-button",
    class: {
      'graph-title-button-active': _vm.isPreloading
    },
    staticStyle: {
      "font-size": "17px"
    },
    attrs: {
      "title": _vm.$l('graphs/preload')
    },
    on: {
      "click": _vm.onPreloadClicked
    }
  }, [_c('icon', {
    attrs: {
      "name": "hourglass-half"
    }
  })], 1), _vm._v(" "), (_vm.isReset) ? _c('div', {
    staticClass: "graph-title-button",
    attrs: {
      "title": _vm.$l('graphs/reset')
    },
    on: {
      "click": _vm.onResetClicked
    }
  }, [_c('i', {
    staticClass: "icon-sync"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.graphType != 'spect' && _vm.config.graphType != 'statistics'),
      expression: "config.graphType != 'spect' && config.graphType != 'statistics'"
    }],
    staticClass: "graph-title-button",
    attrs: {
      "title": _vm.$l('graphs/sync')
    },
    on: {
      "click": _vm.onSyncClicked
    }
  }, [_c('img', {
    staticClass: "weather-sync",
    class: {
      'button-active-bg': _vm.sync
    },
    attrs: {
      "src": require("../../assets/sync.png")
    }
  })]), _vm._v(" "), _c('el-popover', {
    ref: "export-noise-popover",
    attrs: {
      "placement": "bottom",
      "trigger": "click"
    }
  }, [_c('export-graph', {
    attrs: {
      "chart": _vm.$refs.chart
    }
  })], 1), _vm._v(" "), (_vm.$p('graphsexport')) ? _c('div', {
    directives: [{
      name: "popover",
      rawName: "v-popover:export-noise-popover",
      arg: "export-noise-popover"
    }],
    staticClass: "graph-title-button picture-image",
    attrs: {
      "title": _vm.$l('graphs/exportGraph')
    }
  }, [_c('i', {
    staticClass: "el-icon-picture"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "graph-title-button",
    attrs: {
      "title": _vm.$l('graphs/hideShow')
    },
    on: {
      "click": _vm.onHideGraphClicked
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVisible),
      expression: "isVisible"
    }],
    staticClass: "el-icon-arrow-down"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isVisible),
      expression: "!isVisible"
    }],
    staticClass: "el-icon-arrow-right"
  })])], 1), _vm._v(" "), (_vm.config.graphType == 'statistics') ? _c('div', {
    staticClass: "statistics-top"
  }, [_c('div', {
    staticClass: "download-top-bar"
  }, [_c('el-form', {
    staticClass: "inline-form-statistics",
    attrs: {
      "inline": ""
    }
  }, [_c('el-form-item', {
    staticClass: "stat-form-item"
  }, [_c('div', {
    on: {
      "click": _vm.statDayDownloadClicked
    }
  }, [_c('el-button', {
    staticClass: "stat-form-item-button",
    attrs: {
      "size": "small"
    }
  }, [_c('icon', {
    staticClass: "download-stat-icon",
    attrs: {
      "name": "file-word-o"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "stat-form-container"
  }, [_c('el-form', {
    staticClass: "inline-form-statistics",
    attrs: {
      "inline": ""
    }
  }, [_c('el-form-item', {
    staticClass: "stat-form-item"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": _vm.$l('graphs/statTitle')
    },
    model: {
      value: (_vm.statform.title),
      callback: function($$v) {
        _vm.$set(_vm.statform, "title", $$v)
      },
      expression: "statform.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "stat-form-item"
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "picker-options": {
        firstDayOfWeek: 1
      },
      "size": "small",
      "type": "date",
      "placeholder": _vm.$l('graphs/statFrom')
    },
    model: {
      value: (_vm.statform.from),
      callback: function($$v) {
        _vm.$set(_vm.statform, "from", $$v)
      },
      expression: "statform.from"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "stat-form-item"
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "picker-options": {
        firstDayOfWeek: 1
      },
      "size": "small",
      "type": "date",
      "placeholder": _vm.$l('graphs/statTo')
    },
    model: {
      value: (_vm.statform.to),
      callback: function($$v) {
        _vm.$set(_vm.statform, "to", $$v)
      },
      expression: "statform.to"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "stat-form-item"
  }, [_vm._v("\n                                    " + _vm._s(_vm.selectedStatisticsTemplate) + "\n                                ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "stat-form-item"
  }, [_c('div', {
    on: {
      "click": _vm.stateRangeDownloadClicked
    }
  }, [_c('el-button', {
    staticClass: "stat-form-item-button",
    attrs: {
      "size": "small"
    }
  }, [_c('icon', {
    staticClass: "download-stat-icon",
    attrs: {
      "name": "download"
    }
  })], 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "top-barier"
  })]) : _vm._e()]), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.zoomLoading),
      expression: "zoomLoading"
    }],
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.isVisible && _vm.delayedLoading) ? _c('div', {
    staticClass: "delay-loading-container"
  }, [_c('div', {
    staticClass: "delay-loading-text",
    on: {
      "click": _vm.onDelayLoadingClick
    }
  }, [_vm._v(_vm._s(_vm.$l('graphs/load')))])]) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticClass: "real-time-seperator",
    class: {
      'hide-realtime': !_vm.realtimeActive || _vm.config.graphType == 'spect'
    },
    attrs: {
      "lg": 4
    }
  }, [_c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVisible),
      expression: "isVisible"
    }],
    staticClass: "graph-body real-time-container"
  }, [_c('el-row', _vm._l((_vm.latestDataRealtime), function(value, i) {
    return _c('el-col', {
      key: value.name,
      attrs: {
        "lg": 24,
        "sm": (i != 0) ? 8 : 24
      }
    }, [(i == 0) ? _c('div', {
      staticClass: "real-time-date"
    }, [_vm._v("\n                                        " + _vm._s(new Date(parseInt(value.data)).toISOString().slice(0, 10)) + " " + _vm._s(new Date(parseInt(value.data)).toISOString().slice(11, 19)) + "\n                                    ")]) : _vm._e(), _vm._v(" "), (i > 0 && value.data != 'null') ? _c('div', {
      staticClass: "real-time-data"
    }, [_c('div', {
      staticClass: "real-time-data"
    }, [_c('span', {
      staticClass: "real-time-data-title"
    }, [_vm._v(_vm._s(value.name) + ": ")]), _vm._v(_vm._s(value.data) + "\n                                        ")])]) : _vm._e()])
  }), 1)], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": (!_vm.realtimeActive || _vm.config.graphType == 'spect') ? 24 : 20
    }
  }, [_c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVisible),
      expression: "isVisible"
    }],
    staticClass: "graph-body"
  }, [(_vm.errorMessage) ? _c('div', {
    staticClass: "graph-error-message"
  }, [_c('div', {
    staticClass: "error-text"
  }, [_vm._v(_vm._s(_vm.$l(_vm.errorMessage)))])]) : _vm._e(), _vm._v(" "), (_vm.noData) ? _c('div', {
    staticClass: "graph-error-message"
  }, [_c('div', {
    staticClass: "error-text"
  }, [_vm._v(_vm._s(_vm.$l(_vm.noData)))])]) : _vm._e(), _vm._v(" "), _c('highcharts', {
    ref: "chart",
    staticClass: "graph",
    attrs: {
      "options": _vm.graphOptions
    }
  }), _vm._v(" "), (_vm.config.graphType == 'noise' && _vm.getSettingsAddons.markers == '1') ? _c('el-popover', {
    attrs: {
      "placement": "right",
      "value": _vm.markersData.visible,
      "trigger": "manual"
    }
  }, [_c('div', {
    staticClass: "markers-button",
    attrs: {
      "slot": "reference",
      "title": _vm.$l('graphs/markers')
    },
    on: {
      "click": function($event) {
        _vm.markersData.visible = !_vm.markersData.visible
      }
    },
    slot: "reference"
  }, [_c('icon', {
    attrs: {
      "name": "thumb-tack"
    }
  })], 1), _vm._v(" "), _c('markers-popover', {
    attrs: {
      "data": _vm.markersData
    },
    on: {
      "markerClicked": _vm.markerClicked
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.config.graphType == 'noise' && !_vm.realtimeActive && _vm.getSettingsAddons.markers == '1') ? _c('el-popover', {
    attrs: {
      "placement": "right",
      "trigger": "click"
    }
  }, [_c('div', {
    staticClass: "notes-button",
    attrs: {
      "slot": "reference",
      "title": _vm.$l('graphs/dailyNotes')
    },
    slot: "reference"
  }, [_c('icon', {
    attrs: {
      "name": "sticky-note"
    }
  })], 1), _vm._v(" "), _c('graph-notes', {
    attrs: {
      "data": _vm.notesData
    },
    on: {
      "saveClick": _vm.saveDailyNoteClicked
    }
  })], 1) : _vm._e()], 1)])], 1)], 1)], 1)]), _vm._v(" "), (_vm.config.graphType == 'noise' && _vm.graphMarkers.length > 0) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "graph-container markers-container"
  }, [_c('el-table', {
    staticClass: "markers-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": false,
      "data": _vm.graphMarkers
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$l('graphs/markersTable/name')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "marker-color-table",
          style: ({
            backgroundColor: scope.row.color
          })
        }), _vm._v("\n                            " + _vm._s(scope.row.name) + "\n                        ")]
      }
    }], null, false, 1890515269)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$l('graphs/markersTable/startTime')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\n                            " + _vm._s(new Date(scope.row.from).toLocaleString('de-AT', {
          timeZone: 'UTC'
        })) + "\n                        ")]
      }
    }], null, false, 465119353)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$l('graphs/markersTable/endTime')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\n                            " + _vm._s(new Date(scope.row.to).toLocaleString('de-AT', {
          timeZone: 'UTC'
        })) + "\n                        ")]
      }
    }], null, false, 958750644)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$l('graphs/markersTable/type')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\n                            " + _vm._s(scope.row.type ? _vm.$l('graphs/markersCat/toggle') : _vm.$l('graphs/markersCat/single')) + "\n                        ")]
      }
    }], null, false, 2717576922)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "left",
            "width": "400",
            "trigger": "click"
          }
        }, [_c('el-button', {
          attrs: {
            "slot": "reference",
            "type": "text",
            "size": "mini"
          },
          slot: "reference"
        }, [_vm._v(_vm._s(_vm.$l('graphs/markersCat/note')))]), _vm._v(" "), _c('el-input', {
          attrs: {
            "type": "textarea",
            "rows": 4
          },
          model: {
            value: (scope.row.note),
            callback: function($$v) {
              _vm.$set(scope.row, "note", $$v)
            },
            expression: "scope.row.note"
          }
        }), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "margin-top": "10px",
            "width": "100%"
          },
          attrs: {
            "type": "success",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.saveMarkerNoteClicked(scope.row.id)
            }
          }
        }, [_vm._v(_vm._s(_vm.$l('graphs/markersCat/save')))])], 1), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "type": "danger",
            "icon": "delete",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.removeMarker(scope.row.id)
            }
          }
        })]
      }
    }], null, false, 1947296161)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "hourly-notes"
  }, [(_vm.config.graphType == 'noise' && !_vm.realtimeActive && _vm.getSelectedHour != '') ? _c('el-popover', {
    attrs: {
      "placement": "right",
      "trigger": "click"
    }
  }, [_c('el-button', {
    staticClass: "notes-hour-button",
    attrs: {
      "slot": "reference",
      "type": "text",
      "size": "mini"
    },
    slot: "reference"
  }, [_vm._v(_vm._s(_vm.$l('graphs/markersCat/note')))]), _vm._v(" "), _c('graph-notes', {
    attrs: {
      "data": _vm.notesHourlyData
    },
    on: {
      "saveClick": _vm.saveNoteClicked
    }
  })], 1) : _vm._e()], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.savedAudios.length > 0) ? _c('play-audio-dialog', {
    attrs: {
      "data": _vm.playAudioDialog
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72fa60d9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/graphs/Graph.vue
// module id = 471
// module chunks = 1